// extracted by mini-css-extract-plugin
module.exports = {"busy":"busy_busy__2-d21","spin":"busy_spin__3TLll"};